import axios from 'axios'
import { API_BASE_URL } from '@/constants/api-base'

axios.defaults.baseURL = `${API_BASE_URL}/crm`

export default axios
